export { SectionIcon } from './SectionIcon';
export type { SectionIconProps, SectionIconVariant } from './SectionIcon';
